import { render, staticRenderFns } from "./features-showcase.vue?vue&type=template&id=dfb13d94&scoped=true&"
import script from "./features-showcase.vue?vue&type=script&lang=ts&"
export * from "./features-showcase.vue?vue&type=script&lang=ts&"
import style0 from "./features-showcase.vue?vue&type=style&index=0&id=dfb13d94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfb13d94",
  null
  
)

export default component.exports